import { render, staticRenderFns } from "./AccommodationDetails.vue?vue&type=template&id=5cdf2b45&scoped=true"
import script from "./AccommodationDetails.vue?vue&type=script&lang=js"
export * from "./AccommodationDetails.vue?vue&type=script&lang=js"
import style0 from "./AccommodationDetails.vue?vue&type=style&index=0&id=5cdf2b45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cdf2b45",
  null
  
)

export default component.exports